<template>
  <div class="local-btn" @click="$refs.panelLocales.toggle($event)">
    {{ currentLocal }}
  </div>
  <OverlayPanel ref="panelLocales">
    <div v-for="(local, key) in locales" @click="changeLocal(key)" class="local-item" :class="{ 'local-item-active': key === currentLocal }">{{ local }}</div>
  </OverlayPanel>
</template>

<script>
import {loadTranslations} from "@/locales/i18n";
import {getLanguagesApi} from "@/api/properties";
import {mainStore} from "@/store/main";

export default {
  name: "locales",
  data() {
    return {
      locales: [],
      currentLocal: ''
    }
  },
  created() {
    this.getLocale()
  },
  watch: {
    '$i18n.locale'(locale) {
      if (locale) this.currentLocal = locale
    }
  },
  methods: {
    changeLocal(code) {
      loadTranslations(code)
      localStorage.setItem('locale', code)
      this.currentLocal= code
      this.$refs.panelLocales.hide()
    },
    getLocale() {
      getLanguagesApi().then((resp) => {
        this.locales = resp.data.items

        const profileLanguage = mainStore().infoProfile?.language
        const savedLocale = localStorage.getItem("locale")

        let locale =
          (profileLanguage && this.locales[profileLanguage])
            ? profileLanguage
            : savedLocale

        if (!locale || !this.locales[locale]) {
          locale = Object.keys(this.locales)[0] || "en"
        }

        localStorage.setItem("locale", locale)
        loadTranslations(locale)

        this.currentLocal = locale
      }, (error) => {
        loadTranslations('en')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.local-btn {
  margin-right: 20px;
  width: 40px;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
  text-transform: uppercase;
}

.local-item {
  cursor: pointer;
  font-weight: 500;
  text-transform: uppercase;
  padding: 6px 10px;
  border-radius: 6px;

  &:hover {
    color: var(--primary-color);
  }

  &.local-item-active {
    background-color: rgba(41, 112, 201, 0.12);
    color: var(--primary-color);
  }
}

.local-item:not(:last-child) {
  margin-bottom: 10px
}

@media screen and (max-width: 1365px) {
  .local-btn {
    margin-right: 0;
    width: auto;
  }
}
</style>
